import React from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../Stlye.css';
import ServiceFaqSection from '../Components/ServiceFaqSection';
import MetaTags from '../MetaTags';

import BannerImage from '../images/data_banner.jpg';
import Section1Image from '../images/data_sec1.jpg';
import Section2Image from '../images/data_sec2.jpg';

const Dataconsulting = () => {
  return (
    <div>
      <MetaTags
        title="Data Science Services Australia | Smart Resources QLD"
        description="Smart Resources QLD delivers data science services across Australia, from predictive modelling to data strategy. Brisbane based, practical, results focused."
        Canonical="https://smartresourcesqld.com.au/operations/data-science-services-australia"
        DCTitle="Data Science Services Australia | Smart Resources QLD"
        DCDescription="Smart Resources QLD delivers data science services across Australia, from predictive modelling to data strategy. Brisbane based, practical, results focused."
        DCSubject="Data Science Services Australia"
        ogImage={BannerImage}
        ogTitle="Data Science Services Australia | Smart Resources QLD"
        ogDescription="Smart Resources QLD delivers data science services across Australia, from predictive modelling to data strategy. Brisbane based, practical, results focused."
        ogUrl="https://smartresourcesqld.com.au/operations/data-science-services-australia"
      />
      
      <section className="innr_banner" style={{ backgroundImage: `url(${BannerImage})` }}>
        <div className="page_title_innr" data-aos="fade-down">
          <div className="page_title">Data Science Services</div>
          <ul className="bread_crumb">
            <li><NavLink to="/">Home</NavLink></li>
            <li><NavLink to="/operations">Operations</NavLink></li>
            <li>Data Science Services</li>
          </ul>
        </div>
      </section>

      <section className="pricing servinnrbg">
        <div className="servinnng_middle">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="global_left serv_innr_heading" data-aos="fade-up">
                  <h1>Data Science Services Australia</h1>
                  <p style={{ fontSize: '16px' }}>
                    Smart Resources QLD provides data science services to organisations across Australia, working out of South Brisbane. We help businesses move past static reports and spreadsheets, and build a proper data science capability: models that forecast, systems that learn, and processes that turn raw information into decisions your team can act on.
                  </p>
                  <p style={{ fontSize: '16px' }}>
                    Data science is not the same as basic reporting. It draws on statistics, computer science and business context to answer specific questions, such as which customers are likely to leave, where operational risk is building up, or how demand will move over the coming quarter. Our data science team works directly with your existing data, your existing tools and your existing team, so the results fit into how your organisation actually operates.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="discuss-seo seo_price_bg">
          <div className="container">
            <div className="row discuss-ppc-seo">
              <h2 style={{ color: 'white', fontSize: '28px', fontWeight: 600, marginBottom: '10px' }}>What Our Data Science Services Include</h2>
              <p style={{ color: 'white', fontSize: '16px' }}>Our data science services in Australia cover the full path from raw data to a working model, plus the ongoing support needed to keep it accurate.</p>
              <div className="button-ppc-new">
                <NavLink className="btn-trans" to="/contact-us" onClick={() => window.scrollTo(0, 0)}>
                  Book Scoping Call
                </NavLink>
              </div>
            </div>
          </div>
        </div> */}

        
          <div className="include_service_innr">
            <Container>
              <Row className="align-items-start">
                <Col lg="4" md="6" sm="12">
                  <div className="include_img" data-aos="fade-right" style={{ marginLeft: 'unset' }}>
                    <img src={Section1Image} alt="Synthetic data visualization" className="img-fluid" style={{ borderRadius: '20px' }} />
                  </div>
                </Col>

                <Col lg="8" md="6" sm="12">
                  <div className="include_text" data-aos="fade-left" style={{ paddingTop: '20%' }}>
                    <h2 style={{ fontSize: '22px', fontWeight: 600, marginBottom: '20px' }}>What Our Data Science Services Include</h2>
                    <p>Our data science services in Australia cover the full path from raw data to a working model, plus the ongoing support needed to keep it accurate.</p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>

        <div className="include_service_innr">
            <Container>
              <Row>
                <Col lg="12">
                  <div className="include_text" data-aos="fade-up">
                    <h3 style={{ fontSize: '26px', fontWeight: 600, marginBottom: '20px' }}>Predictive Analytics and Forecasting</h3>
                    <p>We build statistical and machine learning models that forecast outcomes such as customer churn, sales demand, cash flow and operational risk. Rather than reporting on what already happened, predictive analytics gives your team lead time to act before an issue or opportunity arrives.</p>
                    <div className="row mt-3">
                      <div className="col-md-3 mb-3">
                        <div style={{ borderLeft: '4px solid #000', paddingLeft: '15px' }}>
                          <h3 style={{ fontSize: '18px', fontWeight: 600 }}>Data Strategy and Roadmapping</h3>
                          <p style={{ fontSize: '14px', color: '#555' }}>Before any model is built, we assess your current data maturity: what data you hold, where it lives, how clean it is, and what decisions it should be supporting. From there we set a practical roadmap, prioritised by business value rather than technical complexity alone.</p>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <div style={{ borderLeft: '4px solid #000', paddingLeft: '15px' }}>
                          <h3 style={{ fontSize: '18px', fontWeight: 600 }}>Machine Learning Model Development</h3>
                          <p style={{ fontSize: '14px', color: '#555' }}>We design, train and validate machine learning models for classification, regression, clustering and anomaly detection, depending on the problem. Every model is tested against real business outcomes before it goes near a production decision.</p>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <div style={{ borderLeft: '4px solid #000', paddingLeft: '15px' }}>
                          <h3 style={{ fontSize: '18px', fontWeight: 600 }}>Data Visualisation and Business Intelligence</h3>
                          <p style={{ fontSize: '14px', color: '#555' }}>Numbers only help if people can read them quickly. We build dashboards and reporting layers on top of the data science work so results are visible to the people who need them, not locked inside a script or a spreadsheet only a data scientist can open.</p>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <div style={{ borderLeft: '4px solid #000', paddingLeft: '15px' }}>
                          <h3 style={{ fontSize: '18px', fontWeight: 600 }}>Data Engineering and Pipeline Development</h3>
                          <p style={{ fontSize: '14px', color: '#555' }}>Good data science depends on data that is collected, cleaned and structured properly first. We set up the pipelines and processes that keep data flowing reliably into your models and reports, so results stay accurate as your data grows.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>

        <section className="include_services" style={{ marginTop: '-30px' }}>
          <div className="include_service_innr">
            <Container>
              <Row className="align-items-start">
                <Col lg="8" md="6" sm="12">
                  <div className="include_text" data-aos="fade-right">
                    <h2 style={{ fontSize: '26px', fontWeight: 600, marginBottom: '20px' }}>Why Businesses Choose Smart Resources QLD</h2>
                    {/* <p>"Synthetic data" is often used loosely, so it's worth being precise about what it means in this context.</p> */}
                    
                    <h3 style={{ fontSize: '20px', fontWeight: 600, marginTop: '25px', marginBottom: '10px' }}>Based in Brisbane, Working Across Australia</h3>
                    <p>
                      We are a South Brisbane based data science and analytics consultancy, and we work with organisations across Queensland and the rest of Australia. Being local means we understand the operating and reporting environment Australian businesses work within, and we build that understanding into every data science engagement.
                    </p>

                    <h3 style={{ fontSize: '20px', fontWeight: 600, marginTop: '5px', marginBottom: '10px' }}>A Practical, Business First Approach</h3>
                    <p>
                      Our data science work starts with a business question, not a technology. We would rather deliver a simple model that gets used every week than a complex one that never leaves the lab. That approach shapes every project we take on.
                    </p>
                    <h3 style={{ fontSize: '20px', fontWeight: 600, marginTop: '5px', marginBottom: '10px' }}>Experienced Data Science Consultants</h3>
                    <p>
                      Our consultants bring hands on experience across statistics, machine learning, data engineering and business analytics, and communicate results in language your team can act on, not just technical output.
                    </p>
                  </div>
                </Col>
                <Col lg="4" md="6" sm="12" className="include_imgpartts">
                  <div className="include_img right" data-aos="fade-left" style={{ marginRight: 'unset' }}>
                    <img src={Section2Image} alt="Data Science - Data has a better idea" className="img-fluid" style={{ borderRadius: '20px', objectFit: 'cover', objectPosition: 'center' }} />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>

          <div className="discuss-seo seo_price_bg">
            <div className="container">
              <div className="row discuss-ppc-seo">
                <h2 style={{ color: 'white', fontSize: '28px', fontWeight: 600, marginBottom: '10px' }}>Industries We Support</h2>
                <p style={{ color: 'white', fontSize: '16px' }}>Data science applies differently depending on the industry. Our team adapts its approach across sectors including financial services, professional services, retail, not for profit organisations and government, working within the data, systems and constraints specific to each.</p>
                <div className="button-ppc-new">
                  <NavLink className="btn-trans" to="/contact-us" onClick={() => window.scrollTo(0, 0)}>
                    Book Scoping Call
                  </NavLink>
                </div>
              </div>
            </div>
          </div>

          <div className="include_service_innr" style={{ marginTop: '30px' }}>
            <Container>
              <Row>
                <Col lg="12">
                  <div className="include_text" data-aos="fade-up">
                    <h2 style={{ fontSize: '26px', fontWeight: 600, marginBottom: '20px' }}>Our Data Science Process</h2>
                    <div className="row mt-4">
                      <div className="col-md-6 mb-4">
                        <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)', height: '100%' }}>
                          <h3 style={{ fontSize: '18px', fontWeight: 600 }}>Step 1 — Discovery and Data Audit</h3>
                          <p style={{ fontSize: '15px', color: '#555', marginTop: '10px' }}>
                            We start by reviewing your current data sources, systems and business questions, and identify where data science can realistically add value in the short and long term.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)', height: '100%' }}>
                          <h3 style={{ fontSize: '18px', fontWeight: 600 }}>Step 2 — Model Design and Development</h3>
                          <p style={{ fontSize: '15px', color: '#555', marginTop: '10px' }}>
                            We design, build and test models against your actual data and business goals, adjusting the approach as results come in rather than following a fixed template.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)', height: '100%' }}>
                          <h3 style={{ fontSize: '18px', fontWeight: 600 }}>Step 3 — Implementation and Handover</h3>
                          <p style={{ fontSize: '15px', color: '#555', marginTop: '10px' }}>
                            Once a model is validated, we integrate it into your existing workflow or reporting tools, and make sure your team understands how it works and how to read its output.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)', height: '100%' }}>
                          <h3 style={{ fontSize: '18px', fontWeight: 600 }}>Step 4 — Ongoing Support and Monitoring</h3>
                          <p style={{ fontSize: '15px', color: '#555', marginTop: '10px' }}>
                            Models drift as data changes. We offer ongoing monitoring and retraining so your data science investment keeps producing accurate results over time.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div> 

          {/* <div className="include_service_innr">
            <Container>
              <Row>
                <Col lg="6" className="mb-4">
                  <div className="include_text" data-aos="fade-right" style={{ backgroundColor: '#f9f9f9', padding: '30px', borderRadius: '20px', height: '100%' }}>
                    <h2 style={{ fontSize: '26px', fontWeight: 600, marginBottom: '20px' }}>Privacy and Accuracy Safeguards</h2>
                    <p>A synthetic dataset is only as trustworthy as the process used to generate and test it. Every dataset produced goes through:</p>
                    <div className="pf">
                      <ul>
                        <li><strong>Differential privacy guarantees:</strong> With a documented privacy budget (epsilon) rather than an unverifiable claim.</li>
                        <li><strong>Re-identification testing:</strong> Including adversarial attacks against the synthetic dataset before it's relied on for anything.</li>
                        <li><strong>Statistical fidelity reporting:</strong> Showing how closely the synthetic twin tracks the real dataset's distributions and relationships.</li>
                        <li><strong>Utility benchmarking:</strong> Comparing model performance on synthetic versus real data so the accuracy trade-off is known upfront, not discovered later.</li>
                      </ul>
                    </div>
                    <p style={{ fontSize: '14px', fontStyle: 'italic', color: '#666', marginTop: '15px' }}>
                      Differential privacy does introduce some statistical noise, and a lower epsilon (stronger privacy) can mean a small reduction in model accuracy. Reporting that trade-off transparently — rather than promising there isn't one — is part of how the process is validated.
                    </p>
                  </div>
                </Col>
                
                <Col lg="6" className="mb-4">
                  <div className="include_text" data-aos="fade-left" style={{ backgroundColor: '#f9f9f9', padding: '30px', borderRadius: '20px', height: '100%' }}>
                    <h2 style={{ fontSize: '26px', fontWeight: 600, marginBottom: '20px' }}>Compliance With the Australian Regulatory Environment</h2>
                    <div style={{ marginTop: '20px' }}>
                      <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '5px' }}>Privacy Act Reforms</h3>
                      <p style={{ fontSize: '14px', color: '#555', marginBottom: '15px' }}>Data minimisation is a recurring theme in the reform agenda. Keeping real personal information out of third-party workflows entirely supports that principle directly.</p>

                      <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '5px' }}>APRA CPS 234</h3>
                      <p style={{ fontSize: '14px', color: '#555', marginBottom: '15px' }}>For APRA-regulated entities, reducing the information security exposure created by third-party arrangements is an explicit requirement. A vendor that never receives real records materially changes that risk assessment.</p>

                      <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '5px' }}>Consumer Data Right (CDR)</h3>
                      <p style={{ fontSize: '14px', color: '#555', marginBottom: '15px' }}>Synthetic data allows exploration of CDR-adjacent use cases and modelling work without directly handling CDR-regulated data flows.</p>

                      <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '5px' }}>Data Sovereignty</h3>
                      <p style={{ fontSize: '14px', color: '#555', marginBottom: '15px' }}>Because the underlying real data never leaves your systems — let alone the country — data residency and sovereignty questions are largely resolved by design.</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div> */}

          {/* <div className="include_service_innr" style={{ paddingBottom: '30px' }}>
            <Container>
              <Row>
                <Col lg="12">
                  <div className="include_text" data-aos="fade-up" style={{ textAlign: 'center' }}>
                    <p>We also provide our Synthetic Data Services in <NavLink to="/operations/synthetic-data-services-australia/brisbane" onClick={() => window.scrollTo(0, 0)}>Brisbane</NavLink>, <NavLink to="/operations/synthetic-data-services-australia/cairns" onClick={() => window.scrollTo(0, 0)}>Cairns</NavLink>, <NavLink to="/operations/synthetic-data-services-australia/rockhampton" onClick={() => window.scrollTo(0, 0)}>Rockhampton</NavLink> and <NavLink to="/operations/synthetic-data-services-australia/townsville" onClick={() => window.scrollTo(0, 0)}>Townsville</NavLink></p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div> */}
        </section>

        <div className="include_service_innr">
          <Container>
            <Row>
              <Col lg="12">
                <div className="include_text" data-aos="fade-up">
                  <h3 style={{ fontSize: '26px', fontWeight: 600, marginBottom: '20px' }}>Data Science and Synthetic Data</h3>
                  <p>Data science and synthetic data services work closely together. Once we understand the patterns in your real data through data science, synthetic data lets you test, share and develop models further without exposing sensitive or regulated information. If your organisation needs to test systems, train models or share data externally without privacy risk, our synthetic data services are a natural next step.</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <ServiceFaqSection
          title="Frequently Asked Questions"
          intro="Quick answers about our synthetic data services."
          faqData={[
            {
              question: 'What is the difference between data science and data analytics?',
              answer: "Data analytics generally looks at historical data to explain what happened. Data science goes further, using statistics and machine learning to predict what is likely to happen next, and to build systems that act on that prediction."
            },
            {
              question: 'How much does a data science project cost in Australia?',
              answer: "Cost depends on the scope of the problem, the state of your existing data, and whether the project is a one off model or an ongoing service. We scope every engagement individually after an initial discovery conversation, rather than applying a fixed package price."
            },
            {
              question: 'Do you work with small and medium businesses, or only large enterprises?',
              answer: "We work with organisations of different sizes. Many of our data science engagements start with a specific, well defined business question rather than a large enterprise wide program, which makes data science accessible to smaller teams too."
            },
            {
              question: 'What tools and platforms do you use for data science projects?',
              answer: "We work with commonly used data science and analytics tools, including Python, SQL and standard business intelligence platforms, and select the specific stack based on what your organisation already uses wherever possible."
            },
            {
              question: 'How long does a typical data science engagement take?',
              answer: "Timelines vary with scope. A focused predictive model can be delivered in a matter of weeks, while a broader data strategy and multiple model program runs longer. We set a realistic timeline during the discovery phase."
            }
          ]}
        />

        <div className="include_service_innr" style={{ paddingBottom: '60px' }}>
          <Container>
            <Row>
              <Col lg="12">
                <div className="include_text" data-aos="fade-up" style={{ backgroundColor: '#000', color: '#fff', padding: '40px', borderRadius: '25px', textAlign: 'center' }}>
                  <h2 style={{ color: '#fff', fontSize: '26px', fontWeight: 600, marginBottom: '20px' }}>Start Your Data Science Project</h2>
                  <p style={{ maxWidth: '800px', margin: '0 auto 30px auto' }}>If your organisation is sitting on data that is not yet being used to its full potential, our data science team can help you turn it into forecasts, models and decisions you can rely on. Get in touch with Smart Resources QLD to talk through your data and where data science could help first.</p>
                  <div className="button-ppc-new mt-4">
                    <NavLink className="btn-trans" to="/contact-us" onClick={() => window.scrollTo(0, 0)} style={{ border: '1px solid #fff', color: '#fff' }}>
                      Book Scoping Call
                    </NavLink>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </div>
  );
};

export default Dataconsulting;